export const DEDUST_GAS_NON_WEI = 0.2;
export const RUBIC_REF_NAME_FOR_DEDUST = 0x3206eb5e;
